import { StoreState } from '@/core/models/store.interface';
import { ActionContext } from 'vuex';
import { PartnerProfession } from './partner-profession.interface';
import { PartnerProfessionService } from './partner-profession.service';
const service = new PartnerProfessionService();

export interface PartnerProfessionState {
   partnerProfessions: Array<PartnerProfession>;
}
const state: PartnerProfessionState = {
   partnerProfessions: [],
};
const getters = {
   partnerProfessions(state: PartnerProfessionState) {
      return state.partnerProfessions;
   },
};
const mutations = {
   SET_PARTNER_PROFESSIONS(state: PartnerProfessionState, partnerProfessions: Array<PartnerProfession>) {
      state.partnerProfessions = partnerProfessions;
   },
};
const actions = {
   async getPartnerProfessions(context: ActionContext<PartnerProfession, StoreState>) {
      return await service.getPartnerProfessions().then((response) => {
         context.commit('SET_PARTNER_PROFESSIONS', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
